import styled from 'styled-components';

export default styled.div`
  .bar-style,.info-style {
    padding: 16px 24px;
    background-color: rgb(255, 255, 255);
    color: rgb(21, 101, 192);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    border-radius: 4px;
    box-shadow: rgba(181, 181, 181, 0.26) 0px 0px 5px 0px;
  }
`;